import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AuthenticationService } from 'src/app/service/translate/authentication.service';
import { TranslateService } from 'src/app/service/translate/translate.service';
import {catchError} from 'rxjs/operators';
import {MonitoringService} from '../../service/utility/monitoring/monitoring.service';
import {FormControl, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {IIdentify} from '../../models/identify.interface';
import {select, Store} from '@ngrx/store';
import {IAppState} from '../../store/state/app.state';
import {selectIdentify} from '../../store/selectors/identify.selectors';

@Component({
  selector: 'app-translate',
  templateUrl: './translate.component.html',
  styleUrls: ['./translate.component.scss']
})
export class TranslateComponent implements OnInit {

  public identify$: Observable<IIdentify>;

  private _languageJSON: any;

  private _languageTransalteJSON: any;

  private _sendingTranslation = false;

  searchText: string;

  isLoading = false;

  objectKeys = Object.keys;

  resourceBase = '1';

  languageBase = 'en-GB';

  resourceTranslate: any;

  languageTranslate: string;

  control = [];

  translateUrlJson = '';
  translateUrlResx = '';
  enableBtnJson = false;
  enableBtnResx = false;



  get languageJSON(): any {
    return this._languageJSON;
  }

  get languageTransalteJSON(): any {
    return this._languageTransalteJSON;
  }

  get sendingTranslation(): boolean {
    return this._sendingTranslation;
  }

  constructor(
    public translateService: TranslateService,
    public authService: AuthenticationService,
    private monitoringService: MonitoringService,
    private router: Router,
    private route: ActivatedRoute,
    private _store: Store<IAppState>,
    ) {

    this.identify$ = this._store.pipe(select(selectIdentify));
    this.getLangTrans(this.resourceBase, this.languageBase, true, true);
    this.translateService.getDropLanguage();
    this.translateService.getDropLanguageTrans();
    this.translateService.getDropResource();

    this.route.queryParams.subscribe((queryParams) => {
      if (queryParams.btndown) {
        if (queryParams.btndown === 'json') {
          this.enableBtnJson = true;
        }
        if (queryParams.btndown === 'resx') {
          this.enableBtnResx = true;
        }
        if (queryParams.btndown === 'json|resx') {
          this.enableBtnJson = true;
          this.enableBtnResx = true;
        }
      }
    });
  }

  ngOnInit() {
  }

  sendTranslation() {
    this.translateService.sentToSlack();
  }

  addKeyValue(group: string, chiave: string, valore: string) {
    this.saveKeyValue(group, chiave, valore);
  }

  removeKeyValue(group: string, chiave: string) {
    this.translateService.deteleItem(this.resourceTranslate.id, group, chiave, this.languageTranslate).subscribe((data: any) => {
      this._sendingTranslation = false;
      if (data.code === 1024) {
        delete this._languageTransalteJSON[group][chiave];
        delete this._languageJSON[group][chiave];
        this.control = [];
      }
    });
  }

  addGroup(group: string) {
    const obj = {
      'resource': this.resourceTranslate.id,
      'description': group
    };
    this.translateService.saveGroup(obj).subscribe((data: any) => {
      this._sendingTranslation = false;
      if (data.code === 1024) {
        this._languageTransalteJSON[obj.description] = {};
        this._languageJSON[obj.description] = {};
        this.control = [];
      }
    });
  }

  removeGroup(group: string) {
    this.translateService.deteleGroup(this.resourceTranslate.id, group).subscribe((data: any) => {
      this._sendingTranslation = false;
      if (data.code === 1024) {
        delete this._languageTransalteJSON[group];
        delete this._languageJSON[group];
        this.control = [];
      }
    });
  }

  saveKeyValue(group: string, chiave: string, valore: string) {
    this._sendingTranslation = true;
    const obj = {
      'resource': this.resourceTranslate.id,
      'language': this.languageTranslate,
      'item': [
        {
          'group': group,
          'key': chiave,
          'value': valore,
          'comment': 'none'
        }
      ]
    };

    this.translateService.saveItem(obj).subscribe((data: any) => {
      this._sendingTranslation = false;
      if (data.code === 1024) {
        this._languageTransalteJSON[obj.item[0].group][obj.item[0].key] = obj.item[0].value;
        if (this.languageTranslate === this.languageBase) {
          this._languageJSON[obj.item[0].group][obj.item[0].key] = obj.item[0].value;
        }
        this.control = [];
      }
    });
  }

  changeLanguageBase() {
    this.getLangTrans(this.resourceBase, this.languageBase, true);
  }

  changeLanguageToTranslate() {
    if (this.languageTranslate && this.resourceTranslate) {
      this.control = [];
      // this.getLangTrans(this.resourceTranslate.id, this.languageBase, true);
      this.getLangTrans(this.resourceTranslate.id, this.languageTranslate, true);
      this.translateUrlJson = this.translateService.getUrlTranslate(this.resourceTranslate.id, this.languageTranslate, 'json');
      this.translateUrlResx = this.translateService.getUrlTranslate(this.resourceTranslate.id, this.languageTranslate, 'resx');
    }
  }

  getLangTrans(resource: string, language: string, base: boolean, first?: boolean) {
    this.isLoading = true;
    let lang = language;
    if (base) {
      lang = this.languageBase;
    }
    this.translateService.getLanguageTranslate(resource, lang).subscribe((data: any) => {
      if (base) {
        this._languageTransalteJSON = [];
        this._languageJSON = data;
        setTimeout(() => {
          this.isLoading = false;
        }, 2000);
        if (base && !first) {
          return this.getLangTrans(resource, language, false);
        }
      } else {
        this._languageTransalteJSON = data;
        this.control = [];
      }
    });
  }

  orderKeys(obj) {
    let keys = this.objectKeys(obj);
    keys = keys.sort(function(a, b) {
      return a.localeCompare(b, undefined, {
        numeric: true,
        sensitivity: 'base'
      });
    });
    return keys;
  }


  initFormControl(value, key, index) {
    if (!this.control[key]) {
      this.control[key] = {};
    }
    if (!this.control[key][index]) {
      this.control[key][index] = {
        value: value,
        stato: false
      };
      return new FormControl(value);
    } else {
      return new FormControl(value);
    }
  }

  detectChange(value, key, i) {
    if (this.control[key]) {
      if (this.control[key][i].value !== value) {
        this.control[key][i].stato = true;
      } else {
        this.control[key][i].stato = false;
      }
    }
  }

  checkChange(key, i) {
    if (this.control[key] && this.control[key][i] && this.control[key][i].stato) {
      return this.control[key][i].stato;
    }
    return false;
  }
}
